/* eslint-disable no-console */

import { register } from "register-service-worker";

if (
  "serviceWorker" in window.navigator &&
  process.env.NODE_ENV === "production"
) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered. Service Worker 已注册");
    },
    cached() {
      console.log(
        "Content has been cached for offline use. 内容已被缓存以供离线使用。"
      );
    },
    updatefound() {
      console.log("New content is downloading. 新内容正在下载。");
    },
    updated() {
      console.log(
        "New content is available; please refresh. 有新内容，请刷新。"
      );
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode. 没有找到网络连接。应用程序在离线模式下运行。"
      );
    },
    error(error) {
      console.error(
        "Error during service worker registration: Service Worker 注册时出错：",
        error
      );
    },
  });
}
